export default "__VITE_ASSET__Bp6gt6np__"